module.exports = __webpack_public_path__ + "img/agentsBox.910944c.jpeg";